module.exports = __webpack_public_path__ + "img/31.7db4d867.jpg";